import { useDragLayer } from "react-dnd";

import DragPreview from "./DragPreview";

export default function CustomDragLayer() {
  const { itemType, isDragging, currentOffset } = useDragLayer((monitor) => ({
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
    itemType: monitor.getItemType(),
  }));

  if (!isDragging || !currentOffset || itemType !== "OrderCard") {
    return null;
  }

  const { x, y } = currentOffset;

  return (
    <div
      style={{
        height: "100%",
        left: 0,
        pointerEvents: "none",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 100,
      }}
    >
      <div
        style={{
          transform: `translate(${x}px, ${y}px)`,
          width: "100%",
        }}
      >
        <DragPreview />
      </div>
    </div>
  );
}
